import axios from 'axios';
import { token, baseUrl } from '../../services/Apis';

export const FILES_CONST = 'files';
export const filesApi = `${baseUrl}/${FILES_CONST}`;

export const uploadFilesService = async (data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  const res = await axios.post(`${filesApi}/upload`, formData, {
    headers: token({
      formData: true,
    }),
  });
  return res;
};
